import { animated, easings, useSpring } from '@react-spring/web';
import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import styled from 'styled-components';

import { usePrevious } from '#src/hooks/usePrevious.ts';

const Root = styled(animated.div)`
  opacity: 0;
  display: none;
  &.show {
    display: block;
  }
`;

export const FadeInOut = ({ children }: PropsWithChildren) => {
  const [show, setShow] = useState(false);
  const previousChildren = usePrevious(children);
  const [style] = useSpring(
    () => ({
      from: { opacity: children ? 0 : 1 },
      to: { opacity: children ? 1 : 0 },
      onStart: () => children && setShow(true),
      onRest: () => setShow(!!children),
      config: {
        duration: 300,
        easing: easings.easeInOutCubic,
      },
    }),
    [children]
  );

  return (
    <Root className={classNames({ show })} style={style}>
      {children || previousChildren}
    </Root>
  );
};
